import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs';
import { AuthService, AssortmentService, SelectedCustomerService } from 'gung-standard';
import { Router } from '@angular/router';

@Component({
    selector: 'colmec-home',
    templateUrl: './colmec-home.component.html',
    styleUrls: ['./colmec-home.component.scss'],
    standalone: false
})
export class ColmecHomeComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService,
    private assortmentService: AssortmentService,
    private selectedCustomerService: SelectedCustomerService
  ) {}

  ngOnInit() {
    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(user => {
        if (user.roles.includes('SALES') || user.roles.includes('ADMIN')) {
          this.router.navigate(['/customers']);
        } else {
          this.router.navigate(['/home']);
        }
      });
  }

  private navigateToFirstSubAssortmentOrDefault(): void {
    this.authService
      .getIsAuthenticated()
      .pipe(first())
      .subscribe(auth => {
        if (auth) {
          this.assortmentService
            .getUserAssortment()
            .pipe(first())
            .subscribe(assortment => {
              const subAssortments = assortment.children
                .filter(a => a.id && a.id.length > 0 && a.id[0] === 's')
                .map(a => {
                  return { route: '/categories/' + a.id, heading: a.name };
                });

              if (subAssortments && subAssortments.length !== 0) {
                this.router.navigateByUrl(subAssortments[0].route);
              } else {
                this.router.navigateByUrl('/products');
              }
            });
        }
      });
  }

  private navigateToSelectedCustomer(): void {
    this.selectedCustomerService
      .getSelectedCustomer()
      .pipe(first())
      .subscribe(customer => {
        this.router.navigateByUrl('/customers/' + customer.id);
      });
  }
}
